import { render, staticRenderFns } from "./ListEstablishmentInternalInvoicePage.vue?vue&type=template&id=2156d9d8"
import script from "./ListEstablishmentInternalInvoicePage.vue?vue&type=script&lang=js"
export * from "./ListEstablishmentInternalInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports